import {BehaviorSubject, combineLatest} from 'rxjs';
import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {contractUtil} from '@px/helper/contract';
import {contract$} from '@px/streams/contract';
import {wwData$} from '@px/streams/worker-data';
import type {RiskUnit} from '@px/streams/ras';

export const riskUnitsCache$ = new BehaviorSubject<Map<string, RiskUnit>>(new Map());

export const crossRiskUnit$ = combineLatest([riskUnitsCache$, contract$]).pipe(
  map(([riskUnitsCache, contract]) => riskUnitsCache.get(contractUtil.getCrossRiskUnitKey(contract.settleCurrency))),
  filter(Boolean),
  startWith({accountBalanceRv: '0', totalOrdUsedBalanceRv: '0', fixedUsedRv: '0'})
);

wwData$
  .pipe(
    filter((o) => o.type === 'risk-unit'),
    map((o): Map<string, RiskUnit> => o.data),
    filter(Boolean),
    startWith(new Map<string, RiskUnit>()),
    shareReplay(1)
  )
  .subscribe((ras) => riskUnitsCache$.next(ras));
